import React from 'react'
import ProgressSvg from "../progresssvg";
import styles from "./progress-svg-component.scss";


const ProgressSvgComponent = (props) => {
  return (
    <div>
        <div className={styles['nudge-status-container'] + ' '+  [props.styleParent || '']}>
            <div className={styles['nudge-status-message-container']}>
                <ProgressSvg />  
                <div>
                    {props.text}
                </div>
            </div>
        
        </div>
    </div>
  )
}

export default ProgressSvgComponent